import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MxTypography from "./MxTypography";
import MxIcons from "./MxIcons";
import { Grid, TypographyProps } from "@mui/material";

export interface MxMenuItemProps<T = any> {
  label: string;
  icon?: React.ReactNode; // icon is now optional
  onClick?: (item: MxMenuItemProps<T>["data"]) => void;
  data?: T;
  show?: boolean; // show is now optional
  template?: React.ReactNode;
  color?: TypographyProps["color"];
}

interface MxMenuProps {
  children: React.ReactNode;
  items: MxMenuItemProps[];
  width?: number | string;
}

const ITEM_HEIGHT = 48;

export default function MxMenu({ children, items, width }: MxMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div onClick={handleClick}>{children}</div>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button"
        }}
        data-testid="mx-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: width || "20ch",
              minWidth: width || "20ch"
            }
          }
        }}
      >
        {items
          .filter(item => item.show !== false) // default show to true
          .map(item =>
            item.template ? (
              React.cloneElement(item.template as any, {
                key: item.label,
                dataTestId: `${item.label}-menu-item`.replace(" ", "-"),
                onClick: (e: any) => {
                  item.onClick?.({
                    context: {
                      ...item.data,
                      detail: e
                    }
                  });
                  handleClose();
                }
              })
            ) : (
              <MenuItem
                key={item.label}
                onClick={() => {
                  item.onClick?.(item.data);
                  handleClose();
                }}
                data-testid={`${item.label}-menu-item`.replace(" ", "-")}
              >
                <Grid container gap={1} alignItems="center">
                  <MxIcons
                    color={item.color ? item.color : "grey.600"}
                    size={16}
                    children={item.icon}
                  />
                  <MxTypography
                    color={item.color ? item.color : "grey.600"}
                    variant="button"
                    children={item.label}
                  />
                </Grid>
              </MenuItem>
            )
          )}
      </Menu>
    </div>
  );
}
